import styled from 'shared/utils/styled';

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
}));
const CommonStyledText = styled('span')(() => ({
  fontWeight: 700,
  color: '#224060',
  textAlign: 'right',
}));

export const Numerator = styled(CommonStyledText)(() => ({}));
export const Denominator = styled(CommonStyledText)(() => ({}));
export const Divider = styled('div')(() => ({
  width: '100%',
  height: 1,
  background: '#707070',
}));
